import { Button, Flex } from 'antd';

import styled from '@emotion/styled';

export const Viewer = styled.div<{ $fill?: boolean }>`
  position: relative;
  ${({ $fill }) =>
    $fill &&
    `
    width: 100%;
    height: 100%;
  `}
`;

export const Wrapper = styled.div<{ width?: string; height?: string }>`
  width: ${({ width }) => (width ? `${width}` : '100%')};
  max-width: ${({ width }) => (width ? `${width}` : '100%')};
  height: ${({ height }) => (height ? `${height}` : '100%')};
  max-height: ${({ height }) => (height ? `${height}` : '100%')};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-top: 5px;
`;

export const DocumentContainer = styled.div<{ $fill?: boolean }>`
  height: 100%;
  overflow-x: auto;
  overflow-y: auto;
  // Fill mode: the page/image is rendered at the frame width, so the container
  // spans the full frame. Kept as a block (not flex) so a zoomed-in page stays
  // scrollable to both edges.
  ${({ $fill }) =>
    $fill &&
    `
    width: 100%;
  `}
`;

// Stage for inline image rendering: fills the frame and centers the image,
// which is scaled with the same zoom controls as the PDF viewer.
export const ImageStage = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  user-select: none;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    transform-origin: center center;
    transition: transform 0.15s ease;
    /* Pan the zoomed image by dragging instead of native image-drag. */
    touch-action: none;
    -webkit-user-drag: none;
  }
`;

export const Panel = styled(Flex, {
  shouldForwardProp: (prop) => prop !== '$floating',
})<{ $floating?: boolean }>`
  width: 258px;
  height: 66px;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.colors.strokeDarkGrey};
  background: ${({ theme }) => theme.colors.badgeGrey};
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.1);

  position: absolute;
  bottom: 30px;
  left: calc(100% - 80%);
  z-index: 2;

  // A4 frame: the panel is positioned via fixed coordinates computed in JS
  // (frame-bottom clamped to the viewport), so it stays reachable even when the
  // frame runs off the bottom of the screen. left is the frame's horizontal
  // center, so translate back by half the panel width to center it.
  ${({ $floating }) =>
    $floating &&
    `
    position: fixed;
    transform: translateX(-50%);
  `}
`;
export const PanelButton = styled(Button)`
  width: 86px;
  height: 66px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 16px 12px 16px;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  gap: 4px;
  color: ${({ theme }) => theme.colors.text400};

  && svg {
    width: 18px;
    height: 18px;
  }
`;

export const PageContainer = styled.div`
  margin-bottom: 16px;
`;
